<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="uberMenuSyncRequest"
	[loading]="!uberMenuSyncRequest"
	[globalFilterFields]="app.keys(uberMenuSyncRequest)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="created">
				<div class="d-flex w-100">
					Request Date

					<p-sortIcon field="created"></p-sortIcon>
					<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="status">
				<div class="d-flex w-100">
					Status

					<p-sortIcon field="status"></p-sortIcon>
					<p-columnFilter
						field="status"
						matchMode="in"
						display="menu"
						[showMatchModes]="false"
						[showOperator]="false"
						[showAddButton]="false"
						class="ms-auto"
					>
						<ng-template pTemplate="header">
							<div class="px-3 pt-3 pb-0">
								<span class="font-bold">Status Picker</span>
							</div>
						</ng-template>
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-multiSelect
								[ngModel]="value"
								[options]="statusValues"
								placeholder="Any"
								(onChange)="filter($event.value)"
								optionLabel="label"
								optionValue="value"
							>
								<ng-template let-option pTemplate="item">
									<div class="p-multiselect-representative-option">
										<span class="ml-1">{{ option.label }}</span>
									</div>
								</ng-template>
							</p-multiSelect>
						</ng-template>
					</p-columnFilter>
				</div>
			</th>
			<th pSortableColumn="updated">
				<div class="d-flex w-100">
					Last Updated

					<p-sortIcon field="updated"></p-sortIcon>
					<p-columnFilter type="date" field="updated" display="menu" class="ms-auto"></p-columnFilter>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>
				{{ app.moment(rec.created).format("l LT") }}
			</td>
			<td>
				{{ rec.status }}
			</td>
			<td>
				{{ app.moment(rec.updated).format("l LT") }}
			</td>
		</tr>
	</ng-template>
</p-table>
